/**
 * Contract-number suffixing for document names.
 *
 * Documents from different contracts routinely share a title — they come from
 * the same template — so a folder of downloads is impossible to tell apart
 * without the contract they belong to. Every name the user sees or downloads
 * therefore ends with the contract number:
 *
 *   {DocumentName}[_v3 | _LockVersion | _signed]_{ContractNumber}.{ext}
 *
 * The existing version / lock / signed markers keep their place; the contract
 * number is always the final segment.
 *
 * The backend carries the same rule in services/documentNaming.js — the two
 * must stay in step, since a download can be named by either side.
 */

/**
 * Append the contract number to a document name.
 *
 * Pass the base name WITHOUT its extension, with any version/lock marker
 * already applied. Missing numbers and names that already carry the number
 * (a re-uploaded download, a manually renamed file) are returned untouched,
 * so the suffix never stacks.
 */
export function withContractNumber(name, contractNumber) {
  const number = contractNumber ? String(contractNumber).trim() : '';
  if (!number) return name;
  if (!name) return number;
  if (String(name).includes(number)) return name;
  return `${name}_${number}`;
}
